import { makeVar } from '@apollo/client';

export const systemUnavailableVar = makeVar(false);

const HEALTH_CHECK_URL = `${import.meta.env.VITE_DB_URL}/health`;
const HEALTH_CHECK_TIMEOUT_MS = 5000;

// The health endpoint is the single authority on whether the backend is
// down. Transport errors from operations only *trigger* a probe; they are
// never treated as proof of an outage on their own.
export const checkBackendHealth = async (): Promise<boolean> => {
  try {
    const res = await fetch(HEALTH_CHECK_URL, {
      method: 'GET',
      cache: 'no-store',
      signal: AbortSignal.timeout(HEALTH_CHECK_TIMEOUT_MS),
    });
    return res.ok;
  } catch {
    return false;
  }
};

let inFlightProbe: Promise<void> | null = null;

// Confirms with /health before declaring the system down, so app-level
// failures (a 5xx from a single operation, a crashing resolver) never
// present as an outage. Concurrent callers share one probe.
export const verifyBackendAvailability = (): void => {
  if (systemUnavailableVar()) return; // screen already up; its retry loop owns recovery
  if (inFlightProbe) return;

  inFlightProbe = checkBackendHealth()
    .then((healthy) => {
      if (!healthy) systemUnavailableVar(true);
    })
    .finally(() => {
      inFlightProbe = null;
    });
};
